export const floatieStylingConstants = {
  floatieDividerHeight: 60,
  floatieRowHeight: 28,
  floatieLargeControlHeight: 60,
  floatieSingleRowFlyoutAnchorWidth: 52,
  floatieSingleRowFlyoutAnchorLabelHeight: 28,
  floatieSingleRowFlyoutAnchorDefaultLabelHeight: 20,
  floatieLargeIconSize: 24,
  menuButtonWidth: 16,
  minimumFloatieLargeControlWidth: 48,
};
